import React, { useSyncExternalStore } from 'react';
import { TAuthority } from 'types/authority.types';
import authorityStore from './authorized.store';

function checkIsAuthorized(currentAuthority: TAuthority[], authority?: TAuthority[] | undefined) {
  if (!authority || authority.length === 0) {
    return true;
  }

  for (let i = 0; i < currentAuthority.length; i += 1) {
    const element = currentAuthority[i];
    if (authority.indexOf(element) >= 0) {
      return true;
    }
  }

  return false;
}

/**========================================================================
 **                        Hooks for permissions
 *========================================================================**/

/**
 * Hook to read current permission store
 * @returns state handlers
 */
export function useAuthority() {
  const store = useSyncExternalStore(authorityStore.subscribe, authorityStore.getSnapshot);
  return [store, authorityStore.setAuthority] as const;
}

/**
 * Get flag if user has permission for given auth
 * @param authority authority to check
 * @returns if user has permission
 */
export function useIsAuthorized(authority?: TAuthority[] | undefined) {
  const [currentAuthority] = useAuthority();

  const isAuthorized = React.useMemo(
    () => checkIsAuthorized(currentAuthority, authority),
    [authority, currentAuthority],
  );

  return isAuthorized;
}

/**
 * Hook to get memorized function for auth
 * @returns function to check authority
 */
export function useAuthorizedCheck() {
  const [currentAuthority] = useAuthority();

  return React.useCallback(
    (authority?: TAuthority[] | undefined) => checkIsAuthorized(currentAuthority, authority),
    [currentAuthority],
  );
}
